import { GET_PROJECT_ACTIONS, LIST_PROJECTS_ACTIONS } from './actionNames';
/**
 * Project caches are keyed by the resolved persona action name (`listDLProjects` or
 * `listAgentDLProjects`, same for get). Mutations don't track which persona is active,
 * so they sweep both names — touching a key with no cache entries is a no-op.
 */
export function invalidateProjectLists(queryClient, email) {
    for (const name of LIST_PROJECTS_ACTIONS) {
        void queryClient.invalidateQueries({ queryKey: [name, email] });
    }
}
export function invalidateProjectDetail(queryClient, email, projectUUID) {
    for (const name of GET_PROJECT_ACTIONS) {
        void queryClient.invalidateQueries({ queryKey: [name, email, projectUUID] });
    }
}
export function removeProjectDetail(queryClient, email, projectUUID) {
    for (const name of GET_PROJECT_ACTIONS) {
        queryClient.removeQueries({ queryKey: [name, email, projectUUID] });
    }
}
